import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, finalize } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { RequestStateService } from '../services/request-state.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private readonly authService: AuthenticationService,
    private readonly requestStateService: RequestStateService) { }

  // tslint:disable-next-line: no-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(environment.host)) {
      return next.handle(request);
    }

    if (this.authService.isLoggedIn && !request.headers.has('Authorization')) {
      request = this.addToken(request, this.authService.getJwtToken());
    }

    this.requestStateService.start();

    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.handle401Error(request, next);
        }
        return throwError(error);
      }),
      finalize(() => this.requestStateService.stop())
    );
  }

  private addToken(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  private handle401Error(request: HttpRequest<unknown>, next: HttpHandler): void {
    this.authService.logout();
    if (location.pathname != '/login') {
      location.href = '/';
    }
  }
}
